import { MultiSelectDesignTokens } from '@primeng/themes/types/multiselect';

export const baseMultiselectToken: MultiSelectDesignTokens = {
  overlay: {
    borderColor: 'transparent',
    borderRadius: '0.5rem',
    shadow: '0px 0.25rem 1.5rem 0px #00000033',
  },
  list: {
    gap: '0',
  },
  option: {
    focusBackground: '{neutral.500}',
    selectedBackground: 'transparent',
    selectedFocusBackground: '{neutral.500}',
    color: '{gray.950}',
    focusColor: '{gray.950}',
    selectedColor: '{gray.950}',
    selectedFocusColor: '{gray.950}',
    padding: '0.25rem 1rem 0.25rem 0.75rem',
    borderRadius: '0.25rem',
    gap: '0.75rem',
  },
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `
    .p-multiselect.multiselect-imitation {
      position: absolute;
      width: 0;
      height: 0;
      border: 0;

      >*:not(p-overlay) {
        display: none;
      }
    }

    .p-multiselect-option {
      font-weight: 500;
    }

    .p-multiselect-option:not(.p-disabled):hover .p-checkbox:not(.p-disabled) .p-checkbox-box {
      outline: ${dt('checkbox.hoverRing.width')} solid ${dt('checkbox.hoverRing.color')};
      outline-offset: ${dt('checkbox.hoverRing.offset')};
    }
    `,
};
